import { type AppDispatch, type RootState } from '../../store'
import _ from 'lodash'
import { modalSlice } from '../../slices/modalSlice'
import { ACCESS_KEY, urlAPI } from '../../../urls'
import { getErrorss } from '../../../functions/errors/GetErrors'

import { setAdvertises } from '../../slices/advertisesSlice'
import notifyDelay from '../../../functions/shared/notify-helpers/notifyDelay'
import dayjs from 'dayjs'
import { sendNotification } from '../../../functions/shared/notifications/sendNotification'
import { getQueryAdvertises } from '../../../functions/shared/api/queries/getQueryAdvertises'

export const checkAForm = (data: Record<string, unknown>, id: number, isApproved: boolean) => async (dispatch: AppDispatch, getState: () => RootState) => {
    const advertise = _.find(getState().advertises.advertises, (advertise: any) => advertise.id === id)
    const jwt = window.localStorage.getItem(ACCESS_KEY) ?? ''

    const StartDate = isApproved && advertise?.attributes.StartDate ?  advertise?.attributes.StartDate :  data.StartDate != null ? dayjs(data.StartDate as any) : null   // .add(4, 'hours')
    const EndDate = isApproved && advertise?.attributes.EndDate ? advertise?.attributes.EndDate : data.EndDate != null ? dayjs(data.EndDate as any) : null
    const RejectReason = !isApproved ? data?.RejectReason : null

    try { 
        dispatch(modalSlice.actions.dataFetchingStart())
        const sendObject = {
            method: 'PUT',
            collection: 'unit-advertises',
            id,
            query: getQueryAdvertises(), // 'populate[User][fields][0]=id&populate[Unit][fields][0]=id',
            body: {
                ...advertise?.attributes,
                Statuses: [isApproved ? 'Confirmed' : 'A Form rejected'],
                StartDate,
                EndDate,
                RejectReason,
                Notify: 'Agent'
            }
        }

        const response = await fetch(`${urlAPI}`, {
            method: 'POST',
            body: JSON.stringify(sendObject),
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${jwt}`
            }
        })
        const dataJSON = await response.json()
        // console.log(dataJSON, 'dataJSON addAgentSettings')
        if (dataJSON.success) {
            if (dataJSON.response.error != null) {
                dispatch(modalSlice.actions.dataFetchingFinish())
                return { ...dataJSON, textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
            } else {
                let notifyRule: string, notifyMessage: string
                if (isApproved) {
                    notifyRule = 'user-advertise-confirmed'
                    notifyMessage = 'The advertise a form is successfully approved'
                    if (!(advertise?.attributes.StartDate != null && advertise?.attributes.EndDate != null)) {
                        await sendNotification(notifyDelay(dayjs(data.StartDate as Date).diff(dayjs(), 'millisecond')), Number(advertise?.attributes?.User?.data?.id), id, 'user-advertise-start', 'Advertise started')
                        await sendNotification(notifyDelay(dayjs(data.EndDate as Date).diff(dayjs(), 'millisecond')), Number(advertise?.attributes?.User?.data?.id), id, 'user-advertise-end', 'Advertise started') 
                        await sendNotification(notifyDelay(dayjs(data.EndDate as Date).subtract(1, 'day').diff(dayjs(), 'millisecond')),
                            Number(advertise?.attributes?.User?.data?.id),
                            id,
                            'user-advertise-heads-up',
                            'Advertise ends in 1 day'
                        );
                    }
                } else {
                    notifyRule = 'user-advertise-a-form-rejected'
                    notifyMessage = 'The advertise a form is rejected'
                }
                await sendNotification(notifyDelay(), Number(advertise?.attributes?.User?.data?.id), id, notifyRule, notifyMessage)
                dispatch(modalSlice.actions.dataFetchingFinish())
                dispatch(setAdvertises(
                    dataJSON.response.data
                ))
                return { ...dataJSON, textNavigate: -2, isSuccessful: true, textNotification: 'You have successfully reviewed the a form' }
            }
        } else {
            dispatch(modalSlice.actions.dataFetchingFinish())
            return { textNavigate: '', isSuccessful: false, textNotification: getErrorss(dataJSON) }
        }
    } catch (error) {
        console.log(error)
        dispatch(modalSlice.actions.dataFetchingFinish())
        return { textNavigate: '', isSuccessful: false, textNotification: 'Something went wrong, try again.' }
        //  dispatch(userSlice.actions.userFetchingError(error))
    }
}
